import React, { useState } from 'react'
import { Modal } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useGetRequest } from '../../../shared/hooks/requests'
import { TENANT_ANALYTICS_LOGS } from '../../../shared/utils/urls'
import Table from '../../../shared/ui/Table'
import { AnalyticsTableItems } from './AnalyticsTableItems'

const cols = [
    { id: 1, title: 'appSource' },
    { id: 2, title: 'appVersionCode' },
    { id: 3, title: 'appVersionName' },
    { id: 4, title: 'attendanceMobileId' },
    { id: 5, title: 'compScore' },
    { id: 6, title: 'createdAt' },
    { id: 7, title: 'detail' },
    { id: 8, title: 'deviceId' },
    { id: 9, title: 'deviceModel' },
    { id: 10, title: 'deviceName' },
    { id: 11, title: 'identityId' },
    { id: 12, title: 'initialImageHash' },
    { id: 13, title: 'lastImageHash' },
    { id: 14, title: 'lat' },
    { id: 15, title: 'lon' },
    { id: 16, title: 'packageId' },
    { id: 17, title: 'statusCode' },
    { id: 18, title: 'tenantEntityId' },
    { id: 19, title: 'timestamp' },
    { id: 20, title: 'trustedTimestamp' },
    { id: 21, title: 'xSignature' },
]

export function AnalyticsLogs({ deviceId, id, title }) {
    const [open, setOpen] = useState(false)
    const getLogs = useGetRequest()
    const logs = getLogs.response ? getLogs.response : []

    const handleOpen = async () => {
        setOpen(true)
        getLogs.request({
            url: TENANT_ANALYTICS_LOGS,
            params: {
                tenant_entity_id: id,
                device_id: deviceId,
            },
        })
    }

    return (
        <>
            <button
                onClick={() => handleOpen()}
                className="px-[15px] font-[500] py-[5px] bg-main-100 text-white rounded-[10px]"
            >
                {title}
            </button>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                className="flex items-center justify-center"
            >
                <div className="w-[900px] flex flex-col items-center gap-[10px] h-[600px] bg-white">
                    <div className="w-full flex cursor-pointer items-center justify-between px-[15px] py-[10px]">
                        <span className="text-[14px] font-[600] text-black">{title}</span>
                        <CloseIcon onClick={() => setOpen(false)} />
                    </div>
                    <div className="w-full p-[10px] h-full bg-white flex flex-col items-center">
                        <Table
                            cols={cols}
                            loading={getLogs.loading}
                            rows={logs}
                            renderItem={(item) => (
                                <AnalyticsTableItems
                                    key={item.id}
                                    item={item}
                                />
                            )}
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}
